module.exports = __webpack_public_path__ + "img/kaguya houraisan_lw.451c7eea.png";